<template>
  <div :class="[baseCss, 'select-none']">
    <table-layout equal-cells y-align="middle" :style="style" :class="[rounded ? 'rounded' : null, `shadow-${elevation}`, 'small-caps', 'transition-all', 'duration-200', 'text-xs', 'text-white', 'font-bold']">
      <row>
        <cell x-align="left" :class="['p-1']" v-html="labels ? strength : ''" />
        <cell x-align="right" :class="['p-1']" v-html="labels ? score : ''" />
      </row>
    </table-layout>
  </div>
</template>
<script>
import methods from '../../mixins/methods'
import props from '../../mixins/props'

export default {
  name: 'PasswordStrengthMeter',
  mixins: [
    props,
    methods
  ],
  data () {
    return {
      baseCss: this.componentBaseCss('password-strength-meter', []),
      score: 0,
      strength: '',
      techStrength: 'weak'
    }
  },
  props: {
    rounded: {
      type: Boolean,
      default: false
    },
    password: {
      type: String,
      required: true
    },
    height: {
      type: String,
      default: 'auto'
    },
    labels: {
      type: Boolean,
      default: true
    },
    colors: {
      type: Object,
      default: () => {
        return {
          weak: 'rgba(244, 63, 94, 1)',
          medium: 'rgba(245, 158, 11, 1)',
          strong: 'rgba(15, 185, 129, 1)'
        }
      }
    },
    lang: {
      type: Object,
      default: () => {
        return {
          weak: 'weak',
          medium: 'medium',
          strong: 'strong'
        }
      }
    }
  },
  watch: {
    password () {
      this.getScore()
      const score = this.score
      const lang = this.lang
      if (score <= 30) {
        this.strength = lang.weak
        this.techStrength = 'weak'
      }
      if (score > 60) {
        this.strength = lang.medium
        this.techStrength = 'medium'
      }
      if (score > 80) {
        this.strength = lang.strong
        this.techStrength = 'strong'
      }
      this.$emit('change', {
        score,
        strength: this.techStrength,
        input: this.password
      })
    }
  },
  computed: {
    style () {
      let gradient = ''
      const score = this.score
      const colors = this.colors
      const weak = colors.weak
      const medium = colors.medium
      const strong = colors.strong
      if (score <= 30) {
        gradient = `${weak}, ${weak}`
      }
      if (score >= 31) {
        gradient = `${weak}, ${medium}`
      }
      if (score > 60) {
        gradient = `${weak}, ${medium}, ${strong}`
      }
      if (score > 80) {
        gradient = `${medium}, ${strong}`
      }
      if (score >= 100) {
        gradient = `${strong}, ${strong}`
      }
      return {
        height: this.height,
        background: `linear-gradient(90deg, ${gradient})`
      }
    }
  },
  methods: {
    getScore () {
      let score = 0
      const pass = this.password
      if (!pass) {
        return score
      }
      let letters = {} // new Object()
      for (let i = 0; i < pass.length; i++) {
        letters[pass[i]] = (letters[pass[i]] || 0) + 1
        score += 5.0 / letters[pass[i]]
      }
      const variations = {
        digits: /\d/.test(pass),
        lower: /[a-z]/.test(pass),
        upper: /[A-Z]/.test(pass),
        nonWords: /\W/.test(pass)
      }
      let variationCount = 0
      for (const check in variations) {
        variationCount += (variations[check] === true) ? 1 : 0
      }
      score += (variationCount - 1) * 10
      this.score = parseInt(score, 10)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/bcq-ui/components/password-strength-meter/password-strength-meter.vue